// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__3n14t","title":"InfoRow_title__1BAH3"};